<template>
  <div class="HotData">
    <div class="HotData_title">
      <i class="iconfont icon-daochu1024-07"></i>
      {{ $t("DataServer.mostPopular") }}
    </div>
    <div class="HotData_content">
      <!-- left -->
      <div class="left_box">
        <div class="type">
          <div class="type_name">{{ $t("DataServer.dataClassification") }}</div>
          <ul>
            <li
              @click="toSearch(item.dataId)"
              v-for="(item, index) in Categories"
              @mouseenter="mouseenterIdx(item.dataId)"
              :key="index"
              :class="[activeId == item.dataId ? 'active' : '']"
            >{{ item.name }}</li>
          </ul>
        </div>
        <div>
          <div v-if="currentList.length > 0" class="content">
            <div v-for="(item, index) in currentList" :key="index" class="data">
              <div class="data_img" @click="toDatadetails(item.dataId)">
                <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
              </div>

              <p>{{ item.productName }}</p>
              <span>{{ item.createInsti }}</span>
            </div>
          </div>
          <div v-else class="noData">
            <img src="@/assets/image/DataHub/noData.png" alt />
            <p>{{ $t("DataServer.noData") }}</p>
          </div>
        </div>
      </div>
      <!-- right -->
      <div class="right_box">
        <p>{{ $t("DataServer.topDataRanking") }}</p>
        <ul>
          <li v-for="(item, index) in TopDataSat" :key="index" @click="toDatadetails(item.data_id)">
            <div class="idx">{{ index + 1 }}</div>
            <div>{{ item.product_name }}</div>
            <i v-if="index == 0 || index == 1 || index == 2" class="iconfont icon-daochu1024-07"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { likeDataSat, topDataSat } from "@/axios/datashare.js";
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    return {
      activeId: null,
      idx: -1,
      HotData: null,
      currentList: [],
      TopDataSat: []
    };
  },
  mounted() {
    this.getTopDataSat().then(res => {
      this.TopDataSat = res.data.data.slice(0, 5);
    });
    this.getLikeDataSat().then(res => {
      this.HotData = res.data.data;
      console.log(this.HotData[0]);
      this.activeId = this.HotData[0].layer;
    });
  },
  methods: {
    toSearch(dataId) {
      this.$router.push(`/dataSearch?keywords=${dataId}`);
    },

    toDatadetails(dataId) {
      // console.log(item)
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
    mouseenterIdx(dataId) {
      this.activeId = dataId;
    },
    // 最受欢迎
    async getLikeDataSat() {
      return await likeDataSat();
    },
    // 热门数据排行榜
    async getTopDataSat() {
      return await topDataSat();
    }
  },
  watch: {
    activeId(val) {
      for (var i = 0; i < this.HotData.length; i++) {
        if (this.HotData[i].layer == val) {
          this.currentList = this.HotData[i].layerList.slice(0, 3);
          return;
        } else {
          this.currentList = [];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .active {
    background: rgba(216, 184, 121, 1) !important;
    color: #fff;
  }
  .HotData {
    width: 100%;
    margin: auto;
    padding: 20px;
    //   height: 300px;
    background: url("../../../assets/image/DataSearch/welcomebg.png");
    background-size: cover;
    display: flex;
    flex-direction: column;
    .HotData_title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 16px;

      i {
        color: #ff952c;
        font-size: 26px;
        margin-left: 10px;
        margin-right: 10px;
      }
      font-weight: 600;
      color: #000;
      font-size: 22px;
    }
    .HotData_content {
      display: flex;
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      flex-direction: row;
      .left_box {
        width: 76%;
        display: flex;
        flex-direction: column;
        .type {
          display: flex;
          flex-direction: row;

          .type_name {
            margin-top: 6px;
            font-weight: 600;
            color: #000;
            font-size: 14px;
            // min-width: 80px;
            margin-right: 10px;
            white-space: nowrap;
          }
          ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            li {
              margin-bottom: 4px;
              padding: 4px 8px;
              background: #f5f5f5;
              border-radius: 12px;
              margin-right: 10px;
              font-size: 14px;
            }
          }
        }
        .content {
          flex: 1;
          display: flex;
          flex-direction: row;
          display: flex;
          margin-top: 20px;
          .data {
            // flex: 1;
             max-width: 265px;
            display: flex;
            flex-direction: column;
            justify-items: flex-start;
            &:hover img {
              transition: 0.2s;
              transform: scale(1.1);
            }
            &:hover p {
              color: #d8b879;
            }
            flex: 1;
            margin-right: 20px;
            cursor: pointer;
            .data_img:last-child {
              margin-right: 0px;
            }
            .data_img {
              overflow: hidden;
              max-width: 265px;
              height: 155px;
              border: 1px solid #e6e6e6;
              img {
                transition: 0.2s;
                width: 100%;
                height: 100%;
              }
            }
            p {
              width: 240px;
              margin-top: 10px;
              font-size: 14px;
              color: #000;
              font-weight: 600;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            span {
              display: inline-block;
              width: 240px;
              margin-top: 6px;
              font-size: 14px;
              color: #999999;
              line-height: 20px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        .noData {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            height: 150px;
            // width: 90px;
          }
          p {
            font-size: 16px;
            color: #ccc;
          }
        }
      }
      .right_box {
        margin-left: 20px;
        flex: 1;
        p {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          line-height: 25px;
        }
        ul {
          padding-top: 25px;
          li {
            display: flex;
            width: 260px;
            flex-direction: row;
            margin-bottom: 21px;

            .idx {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              min-width: 20px;
              height: 20px;
              background: #d8b879;
              border-radius: 2px;
              color: #fff;
              margin-right: 6px;
            }
            div {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
            }
            i {
              color: #ff952c;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .active {
    background: rgba(216, 184, 121, 1) !important;
    color: #fff;
  }
 .HotData {
    width: 100%;
    margin: auto;
    padding: 20px;
    //   height: 300px;
    background: url("../../../assets/image/DataSearch/welcomebg.png");
    background-size: cover;
    display: flex;
    flex-direction: column;
    .HotData_title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 16px;

      i {
        color: #ff952c;
        font-size: 26px;
        margin-left: 10px;
        margin-right: 10px;
      }
      font-weight: 600;
      color: #000;
      font-size: 22px;
    }
    .HotData_content {
      display: flex;
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      flex-direction: row;
      .left_box {
        width: 76%;
        display: flex;
        flex-direction: column;
        .type {
          display: flex;
          flex-direction: row;

          .type_name {
            margin-top: 6px;
            font-weight: 600;
            color: #000;
            font-size: 14px;
            // min-width: 80px;
            margin-right: 10px;
            white-space: nowrap;
          }
          ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            li {
              margin-bottom: 4px;
              padding: 4px 8px;
              background: #f5f5f5;
              border-radius: 12px;
              margin-right: 10px;
              font-size: 14px;
            }
          }
        }
        .content {
          flex: 1;
          display: flex;
          flex-direction: row;
          margin-top: 20px;
          .data {
            &:hover img {
              transition: 0.2s;
              transform: scale(1.1);
            }
            &:hover p {
              color: #d8b879;
            }
            flex: 1;
            margin-right: 20px;
            cursor: pointer;
            .data_img:last-child {
              margin-right: 0px;
            }
            .data_img {
              overflow: hidden;
              // width: 245px;
              height: 155px;
              border: 1px solid #e6e6e6;
              img {
                transition: 0.2s;
                width: 100%;
                height: 100%;
              }
            }
            p {
              width: 240px;
              margin-top: 10px;
              font-size: 14px;
              color: #000;
              font-weight: 600;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            span {
              display: inline-block;
              width: 240px;
              margin-top: 6px;
              font-size: 14px;
              color: #999999;
              line-height: 20px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        .noData {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            height: 150px;
            // width: 90px;
          }
          p {
            font-size: 16px;
            color: #ccc;
          }
        }
      }
      .right_box {
        margin-left: 20px;
        flex: 1;
        p {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          line-height: 25px;
        }
        ul {
          padding-top: 25px;
          li {
            display: flex;
            width: 260px;
            flex-direction: row;
            margin-bottom: 21px;

            .idx {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              min-width: 20px;
              height: 20px;
              background: #d8b879;
              border-radius: 2px;
              color: #fff;
              margin-right: 6px;
            }
            div {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
            }
            i {
              color: #ff952c;
            }
          }
        }
      }
    }
  }
}
</style>